import ResignationTicketDetail from './ResignationTicketDetail';

export default ResignationTicketDetail;
